const editCompany = {
	path: ':customerName?/:customerId?/companies/edit/:companyId',
	name: 'company-edit',
	meta: {
		title: 'Editar Empresa',
	},
	component: () => import('@/components/companies/company-form'),
	props: true,
};
export default editCompany;



// WEBPACK FOOTER //
// ./src/router/companies-edit.js